import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const EditNewsAndEventsSlice = createSlice({
    name: "editNewsAndEvents",
    initialState,
    reducers: {
        editNewsAndEventsRequest(state) {
            state.loading = true;
        },
        editNewsAndEventsRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        editNewsAndEventsRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        editNewsAndEventsStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    editNewsAndEventsRequest,
    editNewsAndEventsRequestSuccess,
    editNewsAndEventsRequestError,
    editNewsAndEventsStateReset
} = EditNewsAndEventsSlice.actions;

export default EditNewsAndEventsSlice.reducer;
